import { render, staticRenderFns } from "./kriDetail.vue?vue&type=template&id=c326cb26&scoped=true&"
import script from "./kriDetail.vue?vue&type=script&lang=js&"
export * from "./kriDetail.vue?vue&type=script&lang=js&"
import style0 from "./kriDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./kriDetail.vue?vue&type=style&index=1&id=c326cb26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c326cb26",
  null
  
)

export default component.exports